import React, { useEffect, useState, useCallback } from "react";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  businessOwnershipType,
  companyLogoUpload,
  diverseSupplierDescription,
  existingCertification,
  getAllIndustryGroups,
  getAllIndustrySubGroups,
  getPlans,
  getUsersList,
  updateEnterprise,
  userAdd,
  userView,
} from "../../../redux/slices/users";
import Multiselect from "multiselect-react-dropdown";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import { useUserSelector } from "../../../redux/selector/users";
import moment from "moment";
import CustomModal from "../../../app/components/common/shared/CustomModal";

const EditEnterpriseUser = () => {
  const location = useLocation();
  const userSelector = useUserSelector();
  const navigate = useNavigate();
  const parts = location.pathname.split("/");
  const userId = parseFloat(parts[parts.length - 1]);
  const dispatch = useDispatch();
  const [paymentCheck, setPaymentCheck] = useState();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    companyName: "",
    roleId: "",
    plan_id: "",
    paymentstatus: "",
    expiryDate: "",
  });

  // State for employees modal
  const [showEmployeesModal, setShowEmployeesModal] = useState(false);
  const [companyEmployees, setCompanyEmployees] = useState([]);

  const [planList, setPlanList] = useState([]);

  const handleChange = (e, fieldname) => {
    const { value, name } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // onchange input
  const handleChangeIndustry = (id, flag) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      plan_id: id,
    }));
  };

  const plans = (e) => {
    dispatch(
      getPlans({
        cb(res) {
          if (res.status) {
            setPlanList(res?.data?.payload);
          } else {
          }
        },
      })
    );
  };

  const getUserInfo = (id) => {
    let params = {
      id: id,
    };
    dispatch(
      userView({
        ...params,
        cb(res) {
          if (res.data) {
            setFormData((prevData) => ({
              ...prevData,
              firstName: res?.data?.payload?.user_profile?.first_name,
              lastName: res?.data?.payload?.user_profile?.last_name,
              email: res?.data?.payload?.email,
              companyName:
                res?.data?.payload?.user_company_information?.company_name,
              roleId: res?.data?.payload?.user_role?.role_id,
              plan_id: res.data.payload?.user_membership_data[0]?.membership_id
                ? res.data.payload?.user_membership_data[0]?.membership_id
                : "1",
              paymentstatus: res?.data?.payload?.is_enterprise_payment_done,
              expiryDate: res?.data?.payload?.expiry_date
                ? moment(res?.data?.payload?.expiry_date).format("YYYY-MM-DD")
                : "",
            }));
            setPaymentCheck(res?.data?.payload?.is_enterprise_payment_done);

            // Set company employees if available
            if (
              res?.data?.payload?.employees &&
              res?.data?.payload?.employees.length > 0
            ) {
              setCompanyEmployees(res?.data?.payload?.employees);
            }
          }
        },
      })
    );
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let letterVal = /^[a-zA-Z\s]*$/;
    if (!formData.plan_id) {
      toast.error("Please select plan");
      return;
    } else if (!formData.paymentstatus) {
      toast.error("Please choose payment status");
      return;
    } else if (!formData.companyName || formData.companyName.trim() === "") {
      toast.error("Please enter Company name");
      return;
    } else if (formData.companyName.length <= 2) {
      toast.error("Company name should be minimum 3 character");
      return;
    } else if (!formData.email) {
      toast.error("Please enter email");
      return;
    } else if (
      formData.email &&
      !/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
        formData.email
      )
    ) {
      toast.error("Please enter valid email address");
      return;
    } else if (!formData.roleId) {
      toast.error("Please Select Role");
      return;
    } else if (
      !formData.firstName ||
      formData.firstName.trim() === "" ||
      formData.firstName.length < 2
    ) {
      toast.error("Please enter first name");
      return;
    } else if (!formData.firstName.match(letterVal)) {
      toast.error("Please enter in first name alphabet characters only");
      return;
    } else if (
      !formData.lastName ||
      formData.lastName.trim() === "" ||
      formData.lastName.length < 2
    ) {
      toast.error("Please enter last name");
      return;
    } else if (!formData.lastName.match(letterVal)) {
      toast.error("Please enter in last name alphabet characters only");
      return;
    }
    let params = {
      id: userId,
      email: formData.email.trim(),
      first_name: formData.firstName,
      last_name: formData.lastName,
      company_name: formData.companyName,
      role_id: formData.roleId,
      business_type: 1,
      plan_id: parseInt(formData.plan_id) ? parseInt(formData.plan_id) : null,
      is_enterprise_payment_done: parseInt(formData.paymentstatus)
        ? parseInt(formData.paymentstatus)
        : 0,
      expiry_date: formData.expiryDate
        ? new Date(formData.expiryDate).toISOString()
        : null,
    };

    if (formData.photo) {
      params = {
        ...params,
        company_logo: formData.photo != "" ? formData.photo : "",
        company_logo_name: formData.photoInfo ? formData.photoInfo.name : "",
        company_logo_size: formData.photoInfo ? formData.photoInfo.size : 0,
      };
    }
    dispatch(
      updateEnterprise({
        ...params,
        cb(res) {
          toast.success(res?.data?.msg);
          navigate("/users");
        },
      })
    );
  };

  useEffect(() => {
    plans();
  }, []);

  useEffect(() => {
    if (userId) {
      getUserInfo(userId);
    }
  }, [userId]);

  return (
    <>
      <div className="containerBox adminDashbord">
        <div className="searchFilter">
          <h3 className="headTxtBlueSmall mb-3">
            Edit Enterprise User
            {companyEmployees && companyEmployees.length > 0 && (
              <span
                className="ms-2 badge bg-primary"
                style={{
                  fontSize: "0.6em",
                  verticalAlign: "middle",
                  cursor: "pointer",
                }}
                onClick={() => setShowEmployeesModal(true)}
              >
                <i className="las la-users me-1"></i>
                {companyEmployees.length} Employees
              </span>
            )}
          </h3>
          <Link to="/users" className="postBtn">
            Go Back
          </Link>
        </div>
        <form className="form mt-5" onSubmit={(e) => handleSubmit(e)}>
          <div className="row">
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Membership Level <span className="fieldMandatory">*</span>
              </label>
              <select
                className="cateSelectbox"
                required=""
                value={formData.plan_id}
                onChange={(e) => {
                  handleChangeIndustry(e.target.value, "");
                }}
              >
                <option value="">Select Plans</option>
                {planList?.length > 0 ? (
                  <>
                    {planList?.map((data) => {
                      return <option value={data.id}>{data.name}</option>;
                    })}
                  </>
                ) : (
                  ""
                )}
              </select>
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Account Activation <span className="fieldMandatory">*</span>
              </label>
              <select
                className="cateSelectbox"
                onChange={(e) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    paymentstatus: e.target.value,
                  }));
                }}
                value={formData.paymentstatus}
              >
                <option value="">Select Payment status</option>
                {paymentCheck === 1 || paymentCheck === 2 ? (
                  ""
                ) : (
                  <option value="0">Account Pending Payment</option>
                )}
                <option value="1">Account Active</option>

                {paymentCheck === 0 ? (
                  ""
                ) : (
                  <option value="2">Account Deactivated</option>
                )}
              </select>
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Company Name <span className="fieldMandatory">*</span>
              </label>
              <input
                name="companyName"
                type="text"
                className="customFormControl"
                value={formData.companyName}
                placeholder="Company Name "
                onChange={(e) => handleChange(e)}
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Email Address <span className="fieldMandatory">*</span>
              </label>
              <input
                onChange={(e) => handleChange(e)}
                value={formData.email}
                autoComplete="off"
                // disabled
                name="email"
                type="email"
                className="customFormControl"
                placeholder="Company Email Address "
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Role<span className="fieldMandatory">*</span>
              </label>
              <select
                className="cateSelectbox"
                onChange={(e) => {
                  setFormData((prevFormData) => ({
                    ...prevFormData,
                    roleId: e.target.value,
                  }));
                }}
                value={formData.roleId}
              >
                <option value="" disabled>
                  I am a ..
                </option>
                <option value="1">Buyer</option>
                <option value="2">Supplier</option>
              </select>
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Expiry Date<span className="fieldMandatory">*</span>
              </label>
              <input
                min={moment().format("YYYY-MM-DD")}
                onChange={(e) => handleChange(e)}
                value={formData.expiryDate}
                name="expiryDate"
                type="date"
                className="customFormControl"
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                First Name <span className="fieldMandatory">*</span>
              </label>
              <input
                onChange={(e) => handleChange(e)}
                value={formData.firstName}
                name="firstName"
                type="text"
                className="customFormControl"
                placeholder="First Name "
              />
            </div>
            <div className="form-group col-md-6 mb-3">
              <label for="" className="customLabel">
                Last Name <span className="fieldMandatory">*</span>
              </label>
              <input
                onChange={(e) => handleChange(e)}
                maxLength={25}
                value={formData.lastName}
                name="lastName"
                type="text"
                className="customFormControl"
                placeholder="Last Name "
              />
            </div>
          </div>
          <div className="col-12 mt-5">
            <div className="d-flex justify-content-end align-items-center">
              <button
                className="submitBtn mt-2 d-inline"
                type="submit"
                onClick={(e) => handleSubmit(e)}
              >
                {userSelector?.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
      {/* Employees Modal */}
      {showEmployeesModal && (
        <CustomModal
          show={showEmployeesModal}
          onCloseModal={() => setShowEmployeesModal(false)}
          backdrop="static"
          size="lg"
          header={<h5 className="modal-title">Company Employees</h5>}
          showCloseBtn={true}
          child={
            <div className="p-3">
              {companyEmployees && companyEmployees.length > 0 ? (
                <div className="table-responsive">
                  <table className="table table-striped">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Joined Date</th>
                        <th>Invite Status</th>
                        <th>Account Status</th>
                        <th>Expiry Date</th>
                      </tr>
                    </thead>
                    <tbody>
                      {companyEmployees.map((employee, index) => (
                        <tr key={index}>
                          <td>
                            {employee?.user_details?.user_profile?.first_name}{" "}
                            {employee?.user_details?.user_profile?.last_name}
                          </td>
                          <td>{employee?.user_details?.email}</td>
                          <td>
                            {moment(employee?.created_at).format("MMM D, YYYY")}
                          </td>
                          <td>
                            {employee?.user_details?.is_invited === 1 ? (
                              <span className="badge bg-warning">Pending</span>
                            ) : employee?.user_details?.is_invited === 2 ? (
                              <span className="badge bg-success">Accepted</span>
                            ) : (
                              <span className="badge bg-secondary">
                                Not Invited
                              </span>
                            )}
                          </td>
                          <td>
                            {employee?.user_details?.is_admin_deactivate ===
                            1 ? (
                              <span className="badge bg-danger">
                                Deactivated
                              </span>
                            ) : employee?.deletedAt ? (
                              <span className="badge bg-danger">Deleted</span>
                            ) : employee?.user_details?.expiry_date &&
                              moment(
                                employee?.user_details?.expiry_date
                              ).isBefore(moment()) ? (
                              <span className="badge bg-danger">Expired</span>
                            ) : (
                              <span className="badge bg-success">Active</span>
                            )}
                          </td>
                          <td>
                            {employee?.user_details?.expiry_date ? (
                              moment(
                                employee?.user_details?.expiry_date
                              ).isBefore(moment()) ? (
                                <span className="text-danger">
                                  {moment(
                                    employee?.user_details?.expiry_date
                                  ).format("MMM D, YYYY")}
                                </span>
                              ) : (
                                moment(
                                  employee?.user_details?.expiry_date
                                ).format("MMM D, YYYY")
                              )
                            ) : (
                              "N/A"
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="text-center py-4">
                  <p>No employees found for this company.</p>
                </div>
              )}
            </div>
          }
          footerContent={
            <button
              className="btn btn-secondary"
              onClick={() => setShowEmployeesModal(false)}
            >
              Close
            </button>
          }
        />
      )}
    </>
  );
};

export default EditEnterpriseUser;
